import { useLocation } from 'react-router';
import React, { createElement } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core';
import styles from './style';
import Box from '../../atomic/Box';
import AddButton from './AddButton';
import List from '../../atomic/List';
import Link from '../../atomic/Link';
import Badge from '../../atomic/Badge';
import Divider from '../../atomic/Divider';
import ListItem from '../../atomic/ListItem';
import ListItemIcon from '../../atomic/ListItemIcon';
import ListItemText from '../../atomic/ListItemText';
import useDashboardLinkPrefix from '../../../hooks/useDashboardLinkPrefix';
import BoligmappaLogoSimple from '../../../assets/icons/BoligmappaLogoSimple';
import NewTag from '../../atomic/NewTag';
import NotificationsTag from '../../atomic/NotificationsTag';
import { sGetPendingRequests } from '../../../store/reducers/accessRequests';
import { enableSurveyor } from '../../../config';

const Sidebar = ({
  items,
  classes,
  listProps,
  showAddButton = true,
  showPropertyListingLink = true,
  pedningAccessRequests,
}) => {
  const { pathname: location } = useLocation();
  const dashboardLinkPrefix = useDashboardLinkPrefix();

  const isActive = (link) => `${dashboardLinkPrefix}/${link}` === location;

  const renderIcon = (icon, link, badgeContent = null) => {
    const Icon = createElement(icon, { className: classes.icon });

    if (!badgeContent) {
      return Icon;
    }

    return (
      <Badge color="primary" badgeContent={badgeContent}>
        {Icon}
      </Badge>
    );
  };

  return (
    <Box height="100%" display="flex" flexDirection="column">
      <List {...listProps}>
        {showAddButton && <AddButton />}

        {items.map(
          ({ link, icon, title, badgeContent, isNew, notificationLabel }) => (
            <Link
              inheritColor
              underline={false}
              key={`sidebar-nav-item-${link}`}
              to={`${dashboardLinkPrefix}/${link}`}
            >
              <ListItem
                button
                disableGutters
                selected={isActive(link)}
                key={`sidebar-item-${link}`}
                className={classes.listItem}
              >
                <ListItemIcon className={classes.listItemIcon}>
                  {renderIcon(icon, link, badgeContent)}
                </ListItemIcon>

                <ListItemText primary={title} className="word-break" />
                {isNew && <NewTag />}
                {notificationLabel &&
                  pedningAccessRequests.length > 0 &&
                  enableSurveyor === 'true' && (
                    <NotificationsTag qty={pedningAccessRequests.length} />
                  )}
              </ListItem>
            </Link>
          )
        )}
      </List>
      <Divider variant="middle" className={classes.divider} />
      <Box
        padding={0}
        flexGrow={1}
        display="flex"
        flexDirection="column"
        justifyContent="flex-end"
        marginBottom="15px"
      >
        {showPropertyListingLink && (
          <Link to="/properties" underline={false} inheritColor>
            <Box display="flex" alignItems="center">
              <Box mr={1}>
                <BoligmappaLogoSimple className={classes.boligmappaLogo} />
              </Box>
              <small>Oversikt over eiendommer</small>
            </Box>
          </Link>
        )}
      </Box>
    </Box>
  );
};
const mapStateToProps = (state) => ({
  pedningAccessRequests: sGetPendingRequests(state),
});
export default connect(mapStateToProps)(withStyles(styles)(Sidebar));
